// themeActions.js
import * as types from "./themeActionTypes";

export const setTheme = (themeMode) => {
  return {
    type: types.SET_THEME,
    payload: themeMode,
  };
};
